import { mergeFragments } from "../../mergeFragments";
import base from "./base";
import receipts from "./receipts";

export default mergeFragments([base, receipts]);
